import "../assets/link.scss";

/**
 * Компонент ссылки, при нажатии на который происходит обработка события клика.
 * @param {*} props 
 * @returns 
 */
export function LinkEvent(props) {
  const {
    onClick = () => {},
    children = [],
  } = props;

  return <a href={'#default'} className={'link'} onClick={handleClick}>{children}</a>;

  function handleClick(event) {
    event.preventDefault();
    onClick(event);
  }
}